import { Container, Logo, Stack } from "@octopus-energy/coral/atoms"

type NavlessHeaderProps = {
    logo?: { src: string; alt: string; width?: string }
    href?: string
}

export function NavlessHeader({ logo, href }: NavlessHeaderProps) {
    return (
        <Container
            height={60}
            margin="auto"
            component="header"
            theme="base900"
        >
            <Stack
                justifyContent="center"
                alignItems="center"
                fullHeight
            >
                {logo ? (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                        src={logo.src}
                        alt={logo.alt}
                    />
                ) : href ? (
                    <a href={href}>
                        <Stack alignItems="center">
                            <Logo
                                variant="logomark"
                                width={40}
                            />
                            <Container paddingTop={{ base: "xs" }}>
                                <Logo
                                    alt="Octopus Energy Logo"
                                    width={240}
                                />
                            </Container>
                        </Stack>
                    </a>
                ) : (
                    <>
                        <Logo
                            variant="logomark"
                            width={40}
                        />
                        <Container paddingTop={{ base: "xs" }}>
                            <Logo
                                alt="Octopus Energy Logo"
                                width={240}
                            />
                        </Container>
                    </>
                )}
            </Stack>
        </Container>
    )
}
